<template>
  <div class="question-editor">
    <div class="question-pd">
      <!-- 题目头部 -->
      <div class="question-header">
        <div class="question-header-left">
          <div>
            <span v-if="isMust" class="asterisk">*</span>
            <span class="question-number">{{
              `${dataObj.questionIndex ? dataObj.questionIndex : index + 1}、`
            }}</span>
          </div>
          <div class="question-select">
            <span>图片单选</span>
          </div>
        </div>
        <div class="question-header-right">
          <img
            v-if="type === 1"
            src="https://ossfastmake.mustke.com/qrCode/tupian/1755596666801.png"
            lazy-load
            class="image-up"
            @click="handleOperateClick(2)"
          />
          <img
            v-if="type === 1"
            src="https://ossfastmake.mustke.com/qrCode/tupian/1755596715787.png"
            lazy-load
            class="image-down"
            @click="handleOperateClick(3)"
          />
          <img
            v-if="type === 1"
            src="https://ossfastmake.mustke.com/qrCode/tupian/1755596748508.png"
            lazy-load
            class="image-delete"
            @click="handleOperateClick(4)"
          />
        </div>
      </div>

      <!-- 题目描述输入框 -->
      <div
        class="textarea-box"
        :style="{
          border:
            isFocusIndex === '-1'
              ? '1px solid rgba(58,96,255,0.5)'
              : '1px solid #DCDDE0',
        }"
      >
        <!-- <textarea
          class="case-problem-textarea textarea-placeholder"
          v-model.lazy="caseProblem"
          placeholder="请选择一个选项"
          maxlength="500"
          :disabled="dataObj.disabled"
          @focus="isFocusIndex = '-1'"
          @blur="isFocusIndex = ''"
          @input="handleUpdate"
        ></textarea>
        <div class="textarea-footer">
          <img
            src="https://ossfastmake.mustke.com/qrCode/tupian/1737857957020.png"
            style="width: 18px; height: 18px; cursor: pointer"
            @click="handleCaseProblemImg"
          />
          <div @click="clearQuestion" class="clear-btn">清空</div>
        </div> -->
        <MyEditor
          v-model="caseProblem"
          placeholder="请选择一个选项"
          @insertImg="handleCaseProblemImg"
          @input="handleInput"
        />
      </div>

      <!-- 题目图片展示 -->
      <div class="question-images">
        <div
          v-for="(item, index) in images"
          :key="index"
          style="margin-top: 10px; position: relative"
        >
          <img :src="item" style="width: 100%" @click="showBigImage(item)" />
          <img
            src="@/assets/images/guanbi.png"
            class="guanbi"
            @click="handleDeleteQuestionImage(index)"
            style="width: 20px; height: 20px; cursor: pointer"
          />
        </div>
      </div>

      <!-- 选项列表（网格布局） -->
      <div class="image-options">
        <div v-for="(option, index) in list" :key="index" class="option-item">
          <!-- 选项图片上传区域 -->
          <div
            v-if="option.img_path === ''"
            class="image-view"
            @click="handleUploadImage(index)"
          >
            <img
              src="@/assets/images/guanbi.png"
              class="del"
              @click.stop="handleDeleteOption(index)"
              style="width: 20px; height: 20px; cursor: pointer"
            />
            <div class="plus-icon"></div>
            <span>点击上传图片</span>
          </div>
          <div v-else class="image-view">
            <img
              src="@/assets/images/guanbi.png"
              class="del"
              @click.stop="handleDeleteOption(index)"
              style="width: 20px; height: 20px; cursor: pointer"
            />
            <img
              :src="option.img_path"
              class="img"
              @click="showBigImage(option.img_path)"
            />
          </div>

          <!-- 选项标题输入 -->
          <div class="content-box">
            <input
              type="text"
              placeholder="请输入标题"
              v-model="option.text"
              @input="handleInputTitle($event, index)"
              maxlength="8"
              class="input-placeholder"
            />
          </div>

          <!-- 选项说明输入 -->
          <div class="content-box">
            <textarea
              v-model="option.context"
              placeholder="说明（限24字,选填）"
              maxlength="24"
              @input="handleInputContent($event, index)"
            ></textarea>
          </div>

          <!-- 选项选中状态 -->
          <div class="content-box checkbox-wrap">
            <el-checkbox
              v-model="option.isChoose"
              label="选择"
              size="mini"
            ></el-checkbox>
          </div>
        </div>
      </div>

      <!-- 图片预览弹窗（替代小程序自定义弹窗） -->
      <el-dialog
        title="图片预览"
        :visible.sync="fangdaShow"
        width="60%"
        @close="fangdaClose"
      >
        <div class="popup-scroll">
          <div>{{ fangdaTitle }}</div>
          <img :src="fangdaImgUrl" style="width: 100%" />
        </div>
      </el-dialog>

      <!-- 操作区域（必选题+添加选项+批量添加） -->
      <div class="add-view">
        <div class="required custom-check-box">
          <el-checkbox
            v-model="isMust"
            label="必选题"
            size="mini"
          ></el-checkbox>
        </div>
        <div @click="addOption" class="add-btn">
          <img
            src="https://ossfastmake.mustke.com/qrCode/tupian/1737858857723.png"
            style="width: 12.5px; height: 12.5px"
          />
          <span>添加选项 {{ list.length + "/50" }}</span>
        </div>
        <div @click="batchAddOptions" class="add-batch">批量添加</div>
      </div>
    </div>

    <!-- 底部按钮 -->
    <div v-if="type === 1" class="question-footer">
      <div class="save-btn" @click="saveClick">保存</div>
    </div>

    <!-- 批量添加弹窗（替代 PopupInput） -->
    <el-dialog
      title="批量添加"
      :visible.sync="showpopup"
      width="40%"
      @close="showpopup = false"
    >
      <el-input
        type="textarea"
        v-model="batchInputValue"
        placeholder="每行输入一个选项（最多50个）"
        rows="10"
      ></el-input>
      <div slot="footer" class="dialog-footer">
        <el-button @click="showpopup = false">取消</el-button>
        <el-button type="primary" @click="bitchConfirm">确定</el-button>
      </div>
    </el-dialog>

    <!-- 上传组件占位（Web端通过input file实现，无需单独组件） -->
    <input
      type="file"
      ref="fileInput"
      accept="image/*"
      style="display: none"
      @change="handleFileChange"
    />
  </div>
</template>

<script>
import axios from "axios";
import baseURL from "../../utils/bsaeUrl";
export default {
  name: "QuestionImageRadio",
  // Vue2 定义Props
  props: {
    params: {
      type: Object,
      default: {},
    },
    index: {
      type: Number,
      default: 0,
    },
    uuid: {
      type: [String, Number],
      default: "",
    },
    type: {
      type: Number,
      default: 1, // 1 添加问卷 2 添加题库
    },
    updateType: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      list: [],
      dataObj: {},
      ifRandomize: false,
      isMust: false,
      showpopup: false, // 批量添加弹窗
      showUpload: false, // 原上传组件标识（Web端无需）
      uploadIndex: 0, // 当前上传索引
      images: [], // 题目图片列表
      caseProblem: "", // 题目描述
      isFocusIndex: "", // 输入框聚焦标识
      inputFocusIndex: "",

      // 替代 Vue3 ref
      fangdaShow: false,
      fangdaImgUrl: "",
      fangdaTitle: "",
      // 批量添加输入值
      batchInputValue: "",
    };
  },
  // Vue2 监听属性
  watch: {
    // 监听dataObj变化
    params: {
      handler(newValue) {
        this.dataObj = { ...newValue };
        this.caseProblem = newValue.caseProblem || "";
        // 解析选项列表
        this.list = (
          JSON.parse(newValue.chooseList || '{"list":[]}').list || []
        ).map((item) => ({
          ...item,
          is_fill: item.is_fill === 1,
          isChoose: item.isChoose || false,
          img_path: item.img_path || "",
        }));
        this.ifRandomize = newValue.ifRandomize === 1;
        this.isMust = newValue.isMust === 1;
        this.images = JSON.parse(newValue.caseProblemImg || "[]");
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    handleOperateClick(type) {
      this.$emit(
        "operate",
        JSON.stringify({
          type: type,
          index: this.index,
        }),
      );
    },
    // 逻辑设置（原代码保留）
    handleLogicClick() {
      console.log(this.dataObj);
      if (this.dataObj.id) {
        this.$emit("logic");
      } else {
        this.$message.warning("请先保存题目");
      }
    },
    // 清空题目描述
    clearQuestion() {
      this.caseProblem = "";
      this.handleUpdate();
    },
    // 添加单个选项
    addOption() {
      if (this.list.length < 50) {
        this.list.push({
          text: "", // 名称
          context: "", // 说明
          isChoose: false, // 是否选择
          img_path: "", // 图片地址
        });
        this.handleUpdate();
      } else {
        this.$message.warning("最多只能添加50个选项");
      }
    },
    // 打开批量添加弹窗
    batchAddOptions() {
      this.batchInputValue = ""; // 清空输入
      this.showpopup = true;
    },
    // 批量添加确认
    bitchConfirm() {
      this.showpopup = false;
      // 解析输入的选项（按换行分割）
      const list = this.batchInputValue
        .split("\n")
        .filter((item) => item.trim() !== "");
      const count = list.length;

      if (count > 50 - this.list.length) {
        this.$message.warning("最多只能添加50个选项");
        return;
      }

      // 生成新选项列表
      const newList = list.map(() => ({
        text: "",
        context: "",
        isChoose: false,
        img_path: "",
      }));
      this.list = this.list.concat(newList);
      this.handleUpdate();
    },
    // 处理选项标题输入（限制8字）
    handleInputTitle(e, index) {
      const value = e.target.value;
      if (value.length > 8) {
        this.list[index].text = value.slice(0, 8);
      }
      this.handleUpdate();
    },
    // 处理选项说明输入（限制24字）
    handleInputContent(e, index) {
      const value = e.target.value;
      if (value.length > 24) {
        this.list[index].context = value.slice(0, 24);
      }
      this.handleUpdate();
    },
    // 上传题目图片
    handleCaseProblemImg() {
      this.uploadIndex = -1;
      this.$refs.fileInput.click(); // 触发文件选择框
    },
    // 上传选项图片
    handleUploadImage(index) {
      this.uploadIndex = index;
      this.$refs.fileInput.click(); // 触发文件选择框
    },
    // Web端文件选择处理
    handleFileChange(event) {
      const file = event.target.files[0];
      const formData = new FormData();
      formData.append("file", file); // "file" 对应后端接收的字段名
      formData.append("uuid", this.uuid);
      this.$refs.fileInput.value = "";
      axios
        .post(baseURL + "/PCwj/file/uploads", formData, {
          headers: {
            "Content-Type": "multipart/form-data", // 必须设置
            token: localStorage.getItem("token"),
          },
        })
        .then((response) => {
          this.$message.success("上传成功！");
          if (this.uploadIndex === -1) {
            this.images = [response.data.urls];
          } else {
            this.list[this.uploadIndex].img_path = [response.data.urls];
          }
          this.handleUpdate();
        })
        .catch((error) => {
          if (axios.isCancel(error)) {
            console.log("上传已取消:", error.message);
          } else {
            this.$message.error("上传失败！");
          }
        });
    },
    // 原上传组件回调（兼容）
    handleUploadComplete(e) {
      if (this.uploadIndex === -1) {
        this.images = e;
      } else {
        this.list[this.uploadIndex].img_path = e;
      }
      this.showUpload = false;
      this.handleUpdate();
    },
    // 删除题目图片
    handleDeleteQuestionImage(index) {
      this.images.splice(index, 1);
      this.handleUpdate();
    },
    // 删除选项
    handleDeleteOption(index) {
      this.list.splice(index, 1);
      this.handleUpdate();
    },
    // 删除选项图片（原代码保留）
    handleDeleteItemImage(index, imgIndex) {
      if (this.list[index].img_path) {
        this.list[index].img_path = "";
      }
      this.handleUpdate();
    },
    // 取消按钮
    cancelClick() {
      this.$emit(
        "cancel",
        JSON.stringify({
          index: this.index,
          data: this.dataObj,
        }),
      );
    },
    // 保存按钮
    saveClick() {
      const imageMcqEmpty = this.list.some((temp) => temp.img_path === "");
      if (imageMcqEmpty) {
        this.$message.error("请上传图片");
        return null;
      }

      // 校验选项图片
      const hasEmptyImg = this.list.some((temp) => !temp.img_path);
      if (hasEmptyImg) {
        this.$message.warning("请上传所有选项的图片");
        return;
      }

      // 组装保存数据
      this.dataObj.isMust = this.isMust ? 1 : 0;
      this.dataObj.caseProblemImg = JSON.stringify(this.images);
      this.dataObj.ifRandomize = this.ifRandomize ? 1 : 0;
      this.dataObj.caseProblem = this.caseProblem || "请选择";
      this.dataObj.chooseList = JSON.stringify({
        list: this.list.map((temp, idx) => ({
          ...temp,
          text: temp.text || `选项${idx + 1}`,
          // context: temp.context || "说明（限制24字）",
          context: temp.context,
        })),
      });

      // 触发保存事件
      this.$emit(
        "save",
        JSON.stringify({
          index: this.index,
          data: this.dataObj,
        }),
      );
    },
    // 实时更新事件
    handleUpdate() {
      this.dataObj.isMust = this.isMust ? 1 : 0;
      this.dataObj.caseProblemImg = JSON.stringify(this.images);
      this.dataObj.ifRandomize = this.ifRandomize ? 1 : 0;
      this.dataObj.caseProblem = this.caseProblem;
      this.dataObj.chooseList = JSON.stringify({
        list: this.list.map((item) => ({ ...item })),
      });

      this.$emit(
        "update",
        JSON.stringify({
          index: this.index,
          data: this.dataObj,
        }),
      );
    },
    // 预览大图
    showBigImage(img, option = {}) {
      this.fangdaShow = true;
      this.fangdaImgUrl = img;
      this.fangdaTitle = option.text || "";
    },
    // 关闭大图预览
    fangdaClose() {
      this.fangdaShow = false;
      this.fangdaImgUrl = "";
      this.fangdaTitle = "";
    },
  },
};
</script>

<style lang="scss" scoped>
// 基础样式重置
* {
  box-sizing: border-box;
}

.question-editor {
  width: 100%;
  // padding: 10px;
  background: #ffffff;
}

.question-pd {
  width: 100%;
}

// 题目头部
.question-header-left {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}

.asterisk {
  color: #f73b42;
  font-weight: bold;
  margin-right: 4px;
}

.question-number {
  font-size: 16px;
  color: #333;
  margin-right: 8px;
}

.question-select {
  font-size: 16px;
  color: #333;
}

// 题目描述输入框
.textarea-box {
  width: 100%;
  background: #ffffff;
  border: 1px solid #dcdde0;
  border-radius: 4px;
  padding: 7px 8px 5px;
  margin-top: 11px;

  .case-problem-textarea {
    width: 100%;
    min-height: 80px;
    border: none;
    outline: none;
    resize: none;
    font-size: 14px;
    color: #4c4a56;
  }

  .textarea-placeholder::placeholder {
    color: #999;
  }

  .textarea-footer {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 4px;
  }
}

// 清空按钮
.clear-btn {
  width: 31px;
  height: 18px;
  background: #ffffff;
  border: 1px solid #3a60ff;
  border-radius: 2.5px;
  font-size: 11px;
  font-weight: 400;
  text-align: center;
  color: #3a60ff;
  line-height: 18px;
  margin-left: 5.5px;
  cursor: pointer;
}

// 题目图片区域
.question-images {
  margin: 10px 0;
  .guanbi {
    position: absolute;
    top: 5px;
    right: 5px;
    z-index: 10;
  }
}

// 选项网格布局
.image-options {
  margin: 10px 0;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 10px;
  justify-content: space-between;

  .option-item {
    width: 100%;
  }
}

// 选项图片区域
.image-view {
  width: 185px;
  height: 185px;
  background: #f4f4f4;
  border-radius: 6.5px;
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  overflow: hidden;
  cursor: pointer;

  .img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  .del {
    position: absolute;
    top: 7.5px;
    right: 7.5px;
    z-index: 10;
  }

  .plus-icon {
    position: relative;
    width: 25px;
    height: 25px;
    margin-top: 58.5px;
    margin-bottom: 8px;

    &::before,
    &::after {
      content: "";
      position: absolute;
      background-color: #b2b7bf;
    }

    &::before {
      left: 50%;
      top: 0;
      width: 1.5px;
      height: 100%;
      transform: translateX(-50%);
    }

    &::after {
      top: 50%;
      left: 0;
      width: 100%;
      height: 1.5px;
      transform: translateY(-50%);
    }
  }

  span {
    font-size: 14px;
    color: #798497;
    margin-top: 14.5px;
  }

  // 隐藏的文件选择框
  .file-input {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    opacity: 0;
    cursor: pointer;
  }
}

// 选项输入框
.content-box {
  width: 185px;
  padding: 6.5px 10px;
  border: 1px dashed #3a60ff;
  border-radius: 4px;
  margin-top: 10px;

  input {
    width: 100%;
    font-size: 16px;
    color: #2b2f36;
    border: none;
    outline: none;
  }

  textarea {
    width: 100%;
    font-size: 16px;
    color: #2b2f36;
    line-height: 20px;
    height: 65px;
    resize: none;
    border: none;
    outline: none;
  }

  .input-placeholder::placeholder {
    color: #999;
  }
}

// 复选框容器
.checkbox-wrap {
  display: flex;
  justify-content: center;
  padding: 5px 0;
}

// 操作区域
.add-view {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 15px 0;
}

.add-btn {
  width: 153px;
  height: 32px;
  background: #ffffff;
  border: 1px solid #00c755;
  border-radius: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;

  span {
    font-size: 14px;
    color: #00c755;
    margin-left: 11px;
  }
}

.add-batch {
  height: 20px;
  font-size: 14px;
  color: #509dee;
  line-height: 20px;
  cursor: pointer;
}

// 隐藏上传框
.hidden-upload {
  display: none;
}

// 图片预览弹窗
.popup-scroll {
  width: 100%;
  padding: 10px;
  div {
    font-size: 16px;
    margin-bottom: 10px;
    color: #333;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/QuestionEdit/QuestionEditImageScq.vue